<template>
 <section class="gray bottom-main pt-4 pb-4">
    <div class="container">
        <div class="row list">
            <div class="col-md-3 col-12 item">
                <span><i class="iconfont iconrenyuan"></i></span>
                <div class="right">
                    <h4>全程服务</h4>
                </div>
            </div>
            <div class="col-md-3 col-12 item">
                <span><i class="iconfont iconfuwu"></i></span>
                <div class="right">
                    <h4>品质保障</h4>
                </div>
            </div>
            <div class="col-md-3 col-12 item">
                <span><i class="iconfont iconicon-test1"></i></span>
                <div class="right">
                    <h4>价格透明</h4>
                </div>
            </div>
            <div class="col-md-3 col-12 item">
                <span><i class="iconfont iconxinxipingtaibaomi2"></i></span>
                <div class="right">
                    <h4>信息保密</h4>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'Safe',
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/common/Safe.vue